import * as React from "react";
const SvgMicrosoftExcel = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#91C174",
  d: "M4 5a3 3 0 0 1 3-3h5v5H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#418B5C",
  d: "M4 12h8v5H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6AA668",
  d: "M4 7h8v5H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#418B5C",
  d: "M4 17h8v5H7a3 3 0 0 1-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BCDE81",
  d: "M12 2h5a3 3 0 0 1 3 3v2h-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6AA668",
  d: "M12 12h8v5h-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#91C174",
  d: "M12 7h8v5h-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#418B5C",
  d: "M12 17h8v2a3 3 0 0 1-3 3h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#105B2B",
  d: "M2.833 7h8.334c.46 0 .833.373.833.833v8.334c0 .46-.373.833-.833.833H2.833A.833.833 0 0 1 2 16.167V7.833c0-.46.373-.833.833-.833"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m4.3 15 1.941-3.008L4.463 9h1.43l.971 1.913q.135.273.184.406h.013q.096-.218.201-.422L8.3 9h1.314L7.79 11.975 9.66 15H8.262l-1.12-2.1a2 2 0 0 1-.135-.28h-.016a1.3 1.3 0 0 1-.13.271L5.706 15z"
}));
export default SvgMicrosoftExcel;
//# sourceMappingURL=MicrosoftExcel.js.map